import { SingleMenuDropdownItem } from '../SingleMenuDropdown/SingleMenuDropdownItem'
import { useIndentOutToggle } from '../../hooks/useIndentOutToggle'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const IndentOutButton = observer(() => {
  const { active, disabled, handleClick } = useIndentOutToggle()

  return (
    <SingleMenuDropdownItem
      icon={<ToolbarIcon name={IconName.IndentDecrease} />}
      label="Indent Out"
      active={active}
      disabled={disabled}
      handleClick={handleClick}
    />
  )
})
